import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoriaProgService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getCategoriaProg(): Observable<any> {
    return this.http.get(this.baseUrl + 'parCategoriaProgramaticas', { headers: this.header(this.token) });
  }

  getCategoriaProgActivos(): Observable<any> {
    return this.http.get(this.baseUrl + 'parCategoriaProgramaticasActivos', { headers: this.header(this.token) });
  }

  getCategoriaProgById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parCategoriaProgramatica/' + id, { headers: this.header(this.token) });
  }

  postCategoriaProg(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'parCategoriaProgramatica', bodyString, { headers: this.header(this.token) });
  }

  putCategoriaProg(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'parCategoriaProgramatica', bodyString, { headers: this.header(this.token) });
  }

  deleteCategoriaProg(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'parCategoriaProgramatica/' + id, { headers: this.header(this.token) });
  }

  getCategoriaProgRpt(gestion: number): Observable<any> {
    return this.http.get(this.baseUrl + 'parCategoriaProgramaticasReporte/' + gestion, { headers: this.header(this.token) });
  }  
  
}
